import React from 'react';
import { Link } from 'react-router-dom';
import { useRooms } from '../context/RoomContext';
import RoomCard from '../components/RoomCard';
import { Hotel, Calendar, Users, Star } from 'lucide-react';

const HomePage: React.FC = () => {
  const { rooms } = useRooms();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-indigo-800 overflow-hidden">
        <div className="absolute inset-0">
          <img
            className="w-full h-full object-cover opacity-30"
            src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
            alt="Luxury hotel"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 py-24 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Welcome to Accommodation Booking
            </h1>
            <p className="text-xl md:text-2xl text-indigo-100 mb-8 max-w-3xl mx-auto">
              Experience luxury and comfort in our premium accommodations. Book your perfect stay today.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/rooms"
                className="inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-50 transition-colors duration-200"
              >
                <Calendar className="mr-2 h-5 w-5" />
                Book Now
              </Link>
              <Link
                to="/rooms"
                className="inline-flex items-center px-8 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white hover:text-indigo-600 transition-colors duration-200"
              >
                <Hotel className="mr-2 h-5 w-5" />
                View Rooms
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
     
      {/* Rooms Section */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Our Premium Rooms
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose from our selection of carefully curated accommodations.
            </p>
          </div>

          {rooms.length > 0 ? (
            <>
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {rooms.slice(0, 6).map((room) => (
                  <RoomCard key={room.id} room={room} />
                ))}
              </div>
              
              {rooms.length > 6 && (
                <div className="mt-12 text-center">
                  <Link
                    to="/rooms"
                    className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 transition-colors duration-200"
                  >
                    View All Rooms
                  </Link>
                </div>
              )}
            </>
          ) : (
            <div className="text-center py-12">
              <Hotel className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-sm font-medium text-gray-900">No rooms available</h3>
              <p className="mt-1 text-sm text-gray-500">Check back later for available accommodations.</p>
            </div>
          )}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-indigo-600">
        <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to Book Your Stay?
            </h2>
            <p className="text-xl text-indigo-100 mb-8 max-w-2xl mx-auto">
              Experience the perfect blend of comfort, luxury, and convenience.
            </p>
            <Link
              to="/rooms"
              className="inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-50 transition-colors duration-200"
            >
              <Calendar className="mr-2 h-5 w-5" />
              Book Your Room Today
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;